// extracted by mini-css-extract-plugin
var _1 = "Input-moduleinput__GPOg4";
export { _1 as "input" }
